export default [
  {
    id: 'teams',
    href: '/app/settings/teams',
    title: 'Create unlimited teams',
    children:
      "Invite as many team members as you want—they're all included in your plan. It's the best tool for your company to automate their work and grow your business.",
    imageAlt: 'Team creation workflow',
    imageSrc:
      'https://zapier-images.imgix.net/storage/photos/ef03e11bc1ce7d5fc2384c0095510626.png',
  },
  {
    id: 'saml',
    href: '/app/settings/company/identity-provider',
    title: 'Set up single-sign on with SAML',
    children:
      'Integrate Zapier with your existing SAML 2.0 identity and access management (IAM) provider to ensure secure access to your team. Built-in connections to popular SSO providers and an option for using your own custom SAML solution.',
    imageAlt: 'SSO sign-in box',
    imageSrc:
      'https://zapier-images.imgix.net/storage/photos/e951bdba733fa9bf83ba2970b542470d.png',
  },
  {
    id: 'domain',
    href: '/app/settings/company/domain',
    title: 'Manage domain insights and account capture in Zapier',
    children:
      'Team admins can see who has created Zapier accounts using a work email address on their verified domain. Account capture helps you make sure your entire company is using a single account. Make sure your security policies are enforced company wide.',
    imageAlt: 'Settings view for company domain',
    imageSrc:
      'https://zapier-images.imgix.net/storage/photos/281bde5d2fbf7c73ff00015cc305bc89.png',
  },
  {
    id: 'scim',
    href: '/app/settings/company/user-provisioning',
    title: 'Provision user accounts with SCIM',
    children:
      'Manage account membership with your identity and access management (IAM) provider to ensure the right people have access. Works with any identity provider that support the SCIM protocol.',
    imageAlt: 'Three icons connected by dotted arrows',
    imageSrc:
      'https://zapier-images.imgix.net/storage/photos/17978f16562744d11bced770af057bdb.png',
  },
  {
    id: 'retention',
    href: '/app/settings/company',
    title: 'Customize task history retention in Zapier',
    children:
      "Customize your task history retention to match your company's legal and regulatory requirements. Or extend your task history up to 90 days to help with troubleshooting.",
    imageAlt: 'Data retention period slider',
    imageSrc:
      'https://zapier-images.imgix.net/storage/photos/fe805db60763074a60e68c7464a16deb.png',
  },
  {
    id: 'app-restriction',
    href: '/app/settings/company/app-restriction',
    title: 'Manage access to apps in Zapier',
    children:
      "You decide which apps can be connected to Zapier. Don't want any data from your CRM connecting to Zapier, no problem. With Access Control for Apps you have control over what data is connected to Zapier.",
    imageAlt: 'Settings view for app permissions',
    imageSrc:
      'https://zapier-images.imgix.net/storage/photos/bd28a02904096f36a96bcddb58a3744c.png',
  },
];
